<template>
<div v-if="device">
    <v-toolbar flat dense color="white">
        <v-btn icon @click="routeToDeviceTable()">
            <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>
            {{device.deviceMakeModel.deviceMake.name}} {{device.deviceMakeModel.name}}: <span v-if="device.ponMac">{{device.ponMac}}</span> <span v-else-if="device.serialNumber">{{device.serialNumber}}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip v-if="device.inStock" color="blue" style="height: 22px" class="white--text">In Stock</v-chip>

        <v-progress-circular v-if="loading" indeterminate color="blue" size="20"></v-progress-circular>
        <div v-else>
            <v-chip style="height: 22px" v-if="onuStatus.show&&onuStatus.isOnline" color="green" class="white--text">Online</v-chip>
            <v-chip style="height: 22px" v-else-if="onuStatus.show&&!onuStatus.isOnline" color="red" class="white--text">Offline</v-chip>
            <v-chip style="height: 22px" v-if="onuStatus.show&&onuStatus.details">Tx: {{parseFloat(onuStatus.details.OPTICSRXPOWER)/100}} dBm</v-chip>
            <v-chip style="height: 22px" v-if="onuStatus.show&&onuStatus.details">Rx: {{parseFloat(onuStatus.details.OPTICSTXPOWER)/100}} dBm</v-chip>

            <v-chip :key="onuKey" style="height: 18px" v-if="onuStatus.rxPower">Rx Power: {{onuStatus.rxPower}} dBm</v-chip>
            <v-chip :key="onuKey" style="height: 18px" v-if="onuStatus.opticRssi">Optic RSSI: {{onuStatus.opticRssi}} dBm</v-chip>
            <v-chip style="height: 22px" v-if="oltstatus.show&&oltstatus.isOnline" color="green" class="white--text">Online</v-chip>
            <v-chip style="height: 22px" v-else-if="oltstatus.show&&!oltstatus.isOnline" color="red" class="white--text">Offline</v-chip>
        </div>
    </v-toolbar>
    <v-divider></v-divider>
    <v-layout justify-start wrap>
        <v-flex xs12 sm8>
            <v-layout justify-start wrap>
                <!-- U2000 Stats -->
                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;" v-if="device.isU2000">
                    <v-list subheader two-line :key="statusKey">
                        <v-subheader style="background: #f0f0f0">System Details</v-subheader>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px" :key="modelKey" v-if="device.deviceMakeModel&&device.deviceMakeModel.deviceMake">
                                            {{device.deviceMakeModel.deviceMake.name}}
                                            <!-- {{device.deviceMakeModel.name}} -->
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px" v-if="device.softwareVersion">
                                            {{device.softwareVersion}}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            {{device.systemName}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="width: 150px">
                                        <v-autocomplete label="Model" ref="deviceMakeModels" v-on:blur="$refs['deviceMakeModels'].blur()" @change="updateDevice()" :items="deviceMakeModels" v-model="device.deviceMakeModel" return-object item-value="id" item-text="name" style="fontSize: 12px;">
                                            <template slot="item" slot-scope="{ item, tile }">
                                                <v-list-tile-content>
                                                    <v-list-tile-title style="font-size: 14px">{{item.name}}</v-list-tile-title>
                                                    <v-list-tile-sub-title style="font-size: 14px">{{item.deviceMake.name}}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </template>
                                        </v-autocomplete>
                                    </v-list-tile-action>
                                </v-list-tile>
                              <v-list-tile v-if="device.location||device.locationNetwork||device.locationNode">
                                    <v-list-tile-action style="font-size: 14px; cursor: pointer" @click="routeToLocation(device)">
                                        <v-icon>location_on</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-if="device.location" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px; cursor: pointer">{{device.location.locationDescription}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.locationNetwork" style="font-size: 14px">{{device.locationNetwork.name}}</v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-else-if="device.location.locationNetwork" style="font-size: 14px">{{device.location.locationNetwork.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.locationNetwork" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.locationNetwork.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.locationNode" style="font-size: 14px">{{device.locationNode.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.locationNode" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.locationNode.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.switchingCentre" style="font-size: 14px">{{device.switchingCentre.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.switchingCentre" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.switchingCentre.name}}</v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="locationSearch=true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                  <v-list-tile v-if="device.inStock || (!device.inStock&&!device.location&&!device.locationNetwork&&!device.locationNode)">
                                      <v-list-tile-action>
                                          <v-icon>warehouse</v-icon>
                                      </v-list-tile-action>
                                      <v-list-tile-content>
                                          <v-list-tile-title>
                                            <span v-if="device.stockWarehouse">{{device.stockWarehouse.name}}</span>  
                                            <span v-else>No Allocated Warehouse</span>
                                          </v-list-tile-title>
                                          <v-list-tile-sub-title v-if="device.stockWarehouse">
Current Storage Location
                                          </v-list-tile-sub-title>
                                      </v-list-tile-content>
                                      <v-list-tile-action>
                                          <v-btn icon v-if="!device.stockWarehouse" @click="addWarehouseModal=true"><v-icon>add</v-icon></v-btn>
                                          <v-btn icon v-else @click="addWarehouseModal=true"><v-icon>refresh</v-icon></v-btn>

                                      </v-list-tile-action>
                                  </v-list-tile>
                            </v-flex>
                            <v-flex xs4 v-if="onuStatus.details">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>power</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">
                                            {{onuStatus.details.OPTICSTXVOL}}mV
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs4 v-if="onuStatus.details">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>straighten</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">
                                            {{onuStatus.details.ONTRANGING}}m
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs4 v-if="onuStatus.details">
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>thermostat</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">
                                            {{onuStatus.details.OPTICSTXTEMP}} C
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                        </v-layout>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>cloud_off</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="font-size: 14px">
                                    Last Offline
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="font-size: 14px">
                                    {{onuStatus.lastDownCause}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="font-size: 12px">
                                <v-chip small>{{formatDateTime(onuStatus.lastDowntime)}}</v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-flex>

                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;" v-else-if="device.isZhone">
                    <v-list subheader two-line :key="statusKey">
                        <v-subheader style="background: #f0f0f0">System Details</v-subheader>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px" :key="modelKey" v-if="device.deviceMakeModel&&device.deviceMakeModel.deviceMake">
                                            {{device.deviceMakeModel.deviceMake.name}}
                                            <!-- {{device.deviceMakeModel.name}} -->
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px" v-if="device.softwareVersion">
                                            {{device.softwareVersion}}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                           {{device.systemName}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="width: 150px">
                                        <v-autocomplete label="Model" ref="deviceMakeModels" v-on:blur="$refs['deviceMakeModels'].blur()" @change="updateDevice()" :items="deviceMakeModels.filter(x=>x.deviceMakeId == device.deviceMakeModel.deviceMakeId)" v-model="device.deviceMakeModel" return-object item-value="id" item-text="name" style="fontSize: 12px;">
                                            <template slot="item" slot-scope="{ item, tile }">
                                                <v-list-tile-content>
                                                    <v-list-tile-title style="font-size: 14px">{{item.name}}</v-list-tile-title>
                                                    <v-list-tile-sub-title style="font-size: 14px">{{item.deviceMake.name}}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </template>
                                        </v-autocomplete>
                                    </v-list-tile-action>
                                </v-list-tile>
                               <v-list-tile v-if="device.location||device.locationNetwork||device.locationNode">
                                    <v-list-tile-action style="font-size: 14px; cursor: pointer" @click="routeToLocation(device)">
                                        <v-icon>location_on</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-if="device.location" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px; cursor: pointer">{{device.location.locationDescription}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.locationNetwork" style="font-size: 14px">{{device.locationNetwork.name}}</v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-else-if="device.location.locationNetwork" style="font-size: 14px">{{device.location.locationNetwork.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.locationNetwork" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.locationNetwork.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.locationNode" style="font-size: 14px">{{device.locationNode.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.locationNode" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.locationNode.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.switchingCentre" style="font-size: 14px">{{device.switchingCentre.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.switchingCentre" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.switchingCentre.name}}</v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="locationSearch=true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile v-if="(!device.inStock) && (!device.location && !device.locationNetwork && !device.locationNode)">
                                    <v-list-tile-action style="font-size: 14px; cursor: pointer">
                                        <v-icon>location_on</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer">
                                        <v-list-tile-title style="font-size: 14px">No Allocated Location</v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="locationSearch=true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile v-if="device.inStock">
                                <!-- <v-list-tile v-if="device.inStock || (!device.inStock&&!device.location&&!device.locationNetwork&&!device.locationNode)"> -->
                                      <v-list-tile-action>
                                          <v-icon>warehouse</v-icon>
                                      </v-list-tile-action>
                                      <v-list-tile-content>
                                          <v-list-tile-title>
                                            <span v-if="device.stockWarehouse">{{device.stockWarehouse.name}}</span>  
                                            <span v-else>No Allocated Warehouse</span>
                                          </v-list-tile-title>
                                          <v-list-tile-sub-title v-if="device.stockWarehouse">
Current Storage Location
                                          </v-list-tile-sub-title>
                                      </v-list-tile-content>
                                      <v-list-tile-action>
                                       <v-btn icon v-if="!device.stockWarehouse" @click="addWarehouseModal=true"><v-icon>add</v-icon></v-btn>
                                          <v-btn icon v-else @click="addWarehouseModal=true"><v-icon>refresh</v-icon></v-btn>

                                      </v-list-tile-action>
                                  </v-list-tile>
                            </v-flex>

                        </v-layout>

                    </v-list>
                </v-flex>


                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;" v-else>
                    <v-list subheader two-line :key="statusKey">
                        <v-subheader style="background: #f0f0f0">System Details <v-spacer></v-spacer><v-btn round icon color="primary" @click="editSystemDetails=true"><v-icon color="white">edit</v-icon></v-btn></v-subheader>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px" :key="modelKey" v-if="device.deviceMakeModel&&device.deviceMakeModel.deviceMake">
                                            {{device.deviceMakeModel.deviceMake.name}}
                                            <!-- {{device.deviceMakeModel.name}} -->
                                        </v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px" v-if="device.softwareVersion">
                                            {{device.softwareVersion}}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            {{device.note}}
                                        </v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action style="width: 150px">
                                        <v-autocomplete label="Model" ref="deviceMakeModels" v-on:blur="$refs['deviceMakeModels'].blur()" @change="updateDevice()" :items="deviceMakeModels.filter(x=>x.deviceMakeId == device.deviceMakeModel.deviceMakeId)" v-model="device.deviceMakeModel" return-object item-value="id" item-text="name" style="fontSize: 12px;">
                                            <template slot="item" slot-scope="{ item, tile }">
                                                <v-list-tile-content>
                                                    <v-list-tile-title style="font-size: 14px">{{item.name}}</v-list-tile-title>
                                                    <v-list-tile-sub-title style="font-size: 14px">{{item.deviceMake.name}}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </template>
                                        </v-autocomplete>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile v-if="device.location||device.locationNetwork||device.locationNode">
                                    <v-list-tile-action style="font-size: 14px; cursor: pointer" @click="routeToLocation(device)">
                                        <v-icon>location_on</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-if="device.location" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px; cursor: pointer">{{device.location.locationDescription}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.locationNetwork" style="font-size: 14px">{{device.locationNetwork.name}}</v-list-tile-sub-title>
                                        <v-list-tile-sub-title v-else-if="device.location.locationNetwork" style="font-size: 14px">{{device.location.locationNetwork.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.locationNetwork" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.locationNetwork.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.locationNode" style="font-size: 14px">{{device.locationNode.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.locationNode" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.locationNode.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.switchingCentre" style="font-size: 14px">{{device.switchingCentre.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer" v-else-if="device.switchingCentre" @click="routeToLocation(device)">
                                        <v-list-tile-title style="font-size: 14px">{{device.switchingCentre.name}}</v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="locationSearch=true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile v-if="(!device.inStock) && (!device.location && !device.locationNetwork && !device.locationNode) && (device.organisationId !== 1)">
                                    <v-list-tile-action style="font-size: 14px; cursor: pointer">
                                        <v-icon>location_on</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content style="font-size: 14px; cursor: pointer">
                                        <v-list-tile-title style="font-size: 14px">No Allocated Location</v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-btn icon @click="locationSearch=true">
                                            <v-icon small>edit</v-icon>
                                        </v-btn>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <!-- <v-list-tile v-if="device.inStock"> -->
                                <v-list-tile v-if="device.inStock || (!device.inStock&&!device.location&&!device.locationNetwork&&!device.locationNode) && (device.organisationId == 1)">
                                      <v-list-tile-action>
                                          <v-icon>warehouse</v-icon>
                                      </v-list-tile-action>
                                      <v-list-tile-content>
                                          <v-list-tile-title>
                                            <span v-if="device.stockWarehouse">{{device.stockWarehouse.name}}</span>  
                                            <span v-else>No Allocated Warehouse</span>
                                          </v-list-tile-title>
                                          <v-list-tile-sub-title v-if="device.stockWarehouse">
Current Storage Location
                                          </v-list-tile-sub-title>
                                      </v-list-tile-content>
                                      <v-list-tile-action>
                                          <v-btn icon v-if="!device.stockWarehouse" @click="addWarehouseModal=true"><v-icon>add</v-icon></v-btn>
                                          <v-btn icon v-else @click="addWarehouseModal=true"><v-icon>refresh</v-icon></v-btn>

                                      </v-list-tile-action>
                                  </v-list-tile>
                            </v-flex>

                        </v-layout>

                    </v-list>
                </v-flex>

                <!-- U2000 Upstream Device -->
                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;" v-if="device.upstreamDevice&&device.upstreamDevice.isU2000&&oltstatus.show">
                    <v-list subheader two-line :key="statusKey">
                        <v-subheader style="background: #f0f0f0">Upstream Device</v-subheader>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-list-tile @click="routeToDeviceSummary(device.upstreamDeviceId)">
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 12px">{{oltstatus.type}} {{oltstatus.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 12px">
                                            {{oltstatus.version}}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="font-size: 12px">
                                            {{oltstatus.ipAddress}}
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-chip v-if="oltstatus.isOnline" style="height: 18px" color="green" class="white--text">Online</v-chip>
                                        <v-chip v-else color="red" style="height: 18px" class="white--text">Offline</v-chip>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-flex>
                            <v-list-tile v-if="device.upstreamDevice.location||device.upstreamDevice.locationNetwork||device.upstreamDevice.locationNode" @click="routeToLocation(device.upstreamDevice)">
                                <v-list-tile-action>
                                    <v-icon v-if="device.upstreamDevice.location">location_on</v-icon>
                                    <v-icon v-else>share</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content v-if="device.upstreamDevice.location">
                                    <v-list-tile-title style="font-size: 14px">{{device.upstreamDevice.location.locationDescription}}</v-list-tile-title>
                                    <v-list-tile-sub-title v-if="device.upstreamDevice.locationNetwork" style="font-size: 14px">{{device.upstreamDevice.locationNetwork.name}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-content v-else-if="device.upstreamDevice.locationNetwork">
                                    <v-list-tile-title style="font-size: 14px">{{device.upstreamDevice.locationNetwork.name}}</v-list-tile-title>
                                    <v-list-tile-sub-title v-if="device.upstreamDevice.locationNode" style="font-size: 14px">{{device.upstreamDevice.locationNode.name}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-content v-else-if="device.upstreamDevice.locationNode">
                                    <v-list-tile-title style="font-size: 14px">{{device.upstreamDevice.locationNode.name}}</v-list-tile-title>
                                    <v-list-tile-sub-title v-if="device.upstreamDevice.switchingCentre" style="font-size: 14px">{{device.upstreamDevice.switchingCentre.name}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-content v-else-if="device.upstreamDevice.switchingCentre">
                                    <v-list-tile-title style="font-size: 14px">{{device.upstreamDevice.switchingCentre.name}}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-flex xs4>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>speed</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">{{oltstatus.cpu}}%</v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px">
                                            CPU Usage
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                </v-list-tile>

                            </v-flex>
                            <v-flex xs4>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>memory</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">{{oltstatus.memory}}%</v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 14px">Memory</v-list-tile-sub-title>

                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex xs4>
                                <v-list-tile>
                                    <v-list-tile-action>
                                        <v-icon>thermostat</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 14px">{{oltstatus.temperature}} C</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                        </v-layout>
                    </v-list>
                </v-flex>

                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;" v-if="device.upstreamDevice&&device.upstreamDevice.isZhone">
                    <v-list subheader two-line :key="statusKey">
                        <v-subheader style="background: #f0f0f0">Upstream Device</v-subheader>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-list-tile @click="routeToDeviceSummary(device.upstreamDeviceId)">
                                    <v-list-tile-content>
                                        <v-list-tile-title style="font-size: 12px">{{device.upstreamDevice.systemName}}</v-list-tile-title>
                                        <v-list-tile-sub-title style="font-size: 12px">
                                            {{device.upstreamDevice.softwareVersion}}
                                        </v-list-tile-sub-title>
                                        <v-list-tile-sub-title style="font-size: 12px">
                                            {{device.upstreamDevice.ipAddress}}
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                    <!-- <v-list-tile-action>
                                        <v-chip v-if="oltstatus.isOnline" style="height: 18px" color="green" class="white--text">Online</v-chip>
                                        <v-chip v-else color="red" style="height: 18px" class="white--text">Offline</v-chip>
                                    </v-list-tile-action> -->
                                </v-list-tile>

                                <v-list-tile v-if="device.upstreamDevice.location||device.upstreamDevice.locationNetwork||device.upstreamDevice.locationNode" @click="routeToLocation(device.upstreamDevice)">
                                    <v-list-tile-action>
                                        <v-icon v-if="device.upstreamDevice.location">location_on</v-icon>
                                        <v-icon v-else>share</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content v-if="device.upstreamDevice.location">
                                        <v-list-tile-title style="font-size: 14px">{{device.upstreamDevice.location.locationDescription}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.upstreamDevice.locationNetwork" style="font-size: 14px">{{device.upstreamDevice.locationNetwork.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else-if="device.upstreamDevice.locationNetwork">
                                        <v-list-tile-title style="font-size: 14px">{{device.upstreamDevice.locationNetwork.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.upstreamDevice.locationNode" style="font-size: 14px">{{device.upstreamDevice.locationNode.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else-if="device.upstreamDevice.locationNode">
                                        <v-list-tile-title style="font-size: 14px">{{device.upstreamDevice.locationNode.name}}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="device.upstreamDevice.switchingCentre" style="font-size: 14px">{{device.upstreamDevice.switchingCentre.name}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else-if="device.upstreamDevice.switchingCentre">
                                        <v-list-tile-title style="font-size: 14px">{{device.upstreamDevice.switchingCentre.name}}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                        </v-layout>
                    </v-list>
                </v-flex>

                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;" v-if="deviceBridges.length>0">
                    <v-list subheader v-if="device.isU2000" two-line>
                        <v-subheader style="background: #f0f0f0">Bridges</v-subheader>
                        <v-list-tile v-for="bridge in deviceBridges" :key="bridge.id" style="border-top: 1px solid lightgrey">
                            <v-list-tile-content>
                                <v-list-tile-title style="fontSize: 12px" v-if="bridge.servicePortId">
                                    {{bridge.servicePortId}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="fontSize: 12px">
                                    Outer vlan: {{bridge.vlanXlate}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 12px" v-if="bridge.vlan">
                                    Inner vlan: {{bridge.vlan}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="font-size: 12px" v-if="bridge.gemportId">Gemport: {{bridge.gemportId}}</v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 10px">
                                    Last Updated: {{formatDateTime(bridge.updatedAt)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 12px">
                                <v-layout justify-center v-if="bridge.downstreamRate">
                                    <v-icon small style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                    {{bridge.downstreamRate}}
                                    <v-icon small style="height: 15px" color="red">arrow_drop_up</v-icon>
                                    {{bridge.upstreamRate}}
                                </v-layout>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                    <v-list subheader three-line v-else-if="device.deviceMakeModel.deviceMake.name.toLowerCase()=='zhone'">
                        <v-subheader style="background: #f0f0f0">Bridges</v-subheader>
                        <v-list-tile v-for="bridge in deviceBridges" :key="bridge.id">
                            <v-list-tile-content>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="bridge.vlan">
                                    Outer vlan: {{bridge.vlan}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="bridge.vlanXlate">
                                    Inner vlan: {{bridge.vlanXlate}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="bridge.tpType">
                                    TP Type: {{tpTypeArray.find(x=>x.id == bridge.tpType).name}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 14px" v-if="bridge.rgMode">
                                    RG Mode: {{rgModeArray.find(x=>x.id == bridge.rgMode).name}}
                                </v-list-tile-sub-title>
                                <v-list-tile-sub-title style="fontSize: 12px">
                                    Last Updated: {{formatDateTime(bridge.updatedAt)}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="fontSize: 12px">
                                <v-layout justify-center v-if="bridge.downstreamRate">
                                    <v-icon small style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                    {{bridge.downstreamRate}}
                                    <v-icon small style="height: 15px" color="red">arrow_drop_up</v-icon>
                                    {{bridge.upstreamRate}}
                                </v-layout>
                                <span style="font-size: 12px" v-if="bridge.tpIndex">Eth Port: <v-chip small>{{bridge.tpIndex}}</v-chip></span>

                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>
                </v-flex>
                <v-flex xs12 md6 style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; border-bottom: 1px solid lightgrey;">
                    <v-list subheader two-line>
                        <v-subheader v-if="serviceAccounts.length>0" style="background: #f0f0f0">Active Service Accounts</v-subheader>
                        <v-list-tile v-for="serviceAccount in serviceAccounts" :key="serviceAccount.id" @click="routeToServiceAccount(serviceAccount.id)">
                            <v-list-tile-avatar>
                                <v-img contain :src="serviceAccount.customerOrganisation.logo"></v-img>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title style="font-size: 14px">
                                    {{serviceAccount.circuitNumber}}
                                </v-list-tile-title>
                                <v-list-tile-sub-title style="font-size: 14px">
                                    {{serviceAccount.customerOrganisation.name}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-layout style="font-size: 12px" justify-center v-if="serviceAccount.packagesIsp&&serviceAccount.packagesIsp.packagesFno&&serviceAccount.packagesIsp.packagesFno.speedProfile">
                                    <v-icon small style="height: 15px" color="light-green">arrow_drop_down</v-icon>
                                    {{serviceAccount.packagesIsp.packagesFno.speedProfile.downloadMbps}}
                                    <v-icon small style="height: 15px" color="red">arrow_drop_up</v-icon>
                                    {{serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps}}
                                </v-layout>
                            </v-list-tile-action>

                        </v-list-tile>
                        <v-subheader style="background: #f0f0f0">Tickets <v-chip v-if="pendingTickets.length > 0">{{pendingTickets.length}}</v-chip>
                            <v-spacer></v-spacer>
                            <v-btn icon color="primary" @click="addTicket()">
                                <v-icon color="white">add</v-icon>
                            </v-btn>
                        </v-subheader>
                        <v-tabs grow v-if="resolvedTickets.length>0" v-model="ticketTab">
                            <v-tab>Pending</v-tab>
                            <v-tab>Resolved</v-tab>
                        </v-tabs>
                        <v-list v-if="ticketTab==0">
                            <v-list-tile v-for="pending in pendingTickets" :key="pending.id" @click="routeToTicketSummary(pending.id)">
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px" v-if="pending.name">
                                        {{pending.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-title style="font-size: 14px" v-else>
                                        <span v-if="pending.ticketCategory">{{pending.ticketCategory.name}} </span>
                                        <span v-else-if="pending.ticketCategoryItem.ticketCategory">{{pending.ticketCategoryItem.ticketCategory.name}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 14px">{{pending.ticketCategoryItem.name}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-chip style="height: 18px" :class="`${pending.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`">{{pending.currentStatus}}</v-chip>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="pendingTickets.length == 0">
                                <v-list-tile-sub-title style="font-size: 14px">
                                    No Pending Tickets.
                                </v-list-tile-sub-title>
                            </v-list-tile>
                        </v-list>
                        <v-list v-else>
                            <v-list-tile v-for="resolved in resolvedTickets" :key="resolved.id" @click="routeToTicketSummary(resolved.id)">
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size: 14px" v-if="resolved.name">
                                        {{resolved.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-title style="font-size: 14px" v-else>
                                        <span v-if="resolved.ticketCategory">{{resolved.ticketCategory.name}} </span>
                                        <span v-else-if="resolved.ticketCategoryItem.ticketCategory">{{resolved.ticketCategoryItem.ticketCategory.name}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title style="font-size: 14px">{{resolved.ticketCategoryItem.name}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-chip style="height: 18px" :class="`${resolved.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`">{{resolved.currentStatus}}</v-chip>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-list>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 sm4 class="text-xs-left">
            <v-tabs grow v-model="commentTab">
                <v-tab>
                    <v-icon class="mx-1">chat</v-icon> Comments
                </v-tab>
                <v-tab>
                    <v-icon class="mx-1">timeline</v-icon>Timeline
                </v-tab>

            </v-tabs>

            <div v-if="commentTab==0">
                <!-- <v-subheader style="background: #f0f0f0">Comments</v-subheader> -->

                <i style="font-size: 12px;" class="pl-3">These comments are for internal use only</i>
                <v-layout align-center justify-center wrap class="ma-2">
                    <v-flex xs10>
                        <at-ta :members="members" v-model="comment">
                            <v-textarea auto-grow rows="2" outline></v-textarea>
                        </at-ta>
                    </v-flex>
                    <v-flex xs2 class="text-xs-left pl-3">
                        <v-btn icon @click="addComment()">
                            <v-icon>send</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>

                <div style="overflow-y: auto; max-height: 50vh;">

                    <v-layout v-for="item in comments" :key="item.id" justify-start align-center style="border-bottom: 1px solid lightgrey">
                        <v-flex xs3 class="text-xs-left ml-1">
                            <b>{{ item.contact.name
                            }} {{ item.contact.surname}}</b>
                            <!-- <small>{{item.organisation.name}}</small>  -->
                            <br />
                            <span style="color: grey; font-size: 10px">{{ formatDateTime(item.createdAt) }}</span>
                        </v-flex>
                        <v-flex class="text-xs-left pa-2" xs8>

                            <span class="darkgrey--text text-xs-left" v-html="item.comment"></span>
                        </v-flex>
                    </v-layout>
                </div>

            </div>
            <div v-else style="overflow-y: auto; max-height: 70vh; padding: 5px">
                <v-timeline dense>
                    <v-timeline-item fill-dot v-for="item in deviceLogHistory" :icon="getIcon(item.type)" :color="item.color?item.color:'grey'" :key="item.id">
                        <v-card @click="item.id?routeTimeline(item):null">
                            <v-card-text style="font-size: 12px">
                                <span v-html="item.action"></span>
                                <br />
                                <span style="color: grey; font-size: 10px">{{ formatDateTime(item.date) }}</span>
                            </v-card-text>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>
            </div>
        </v-flex>
    </v-layout>

    <v-dialog v-model="addTicketModal" width="1200px" persistent>
        <v-card>
            <TicketSummaryModal :ticket="ticket" @close="addTicketModal=false, ticket={}" @ticketCreated="addTicketModal=false,fetchDeviceTickets()" />
        </v-card>
    </v-dialog>

     <v-dialog v-model="locationSearch" width="400px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Location Search
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="locationSearch = false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center wrap>
                        <v-flex xs10>
                            <v-autocomplete class="px-2" box dense ref="locationNodeId" return-object clearable v-on:blur="$refs['locationNodeId'].blur()" :items="locationNodes" item-text="name" item-value="id" v-model="device.locationNode" label="Location Node"></v-autocomplete>

                        </v-flex>
                        <v-flex xs10>
                            <v-autocomplete box :disabled="!device.locationNode" return-object class="px-2" dense ref="locationNetworkId" clearable v-on:blur="$refs['locationNetworkId'].blur()" :items="filteredNetworks" item-text="name" item-value="id" v-model="device.locationNetwork"  @change="fetchLocations()" label="Network"></v-autocomplete>

                        </v-flex>
                        <v-flex xs10>
                            <v-progress-circular color="primary" v-if="loadingLocations" indeterminate></v-progress-circular>
                            <v-autocomplete v-else box :disabled="!device.locationNetwork" return-object class="px-2" dense ref="locationId" v-on:blur="$refs['locationId'].blur()" clearable :items="locations" item-text="locationDescription" item-value="id" v-model="device.location" label="Location"></v-autocomplete>

                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn flat color="primary" @click="locationSearch = false,updateDevice()">Done</v-btn>
                        </v-flex>

                    </v-layout>
            </v-card-text>
        </v-card>

    </v-dialog>

    <v-dialog v-model="editSystemDetails" width="750px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>System Details</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="editSystemDetails=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center wrap>
                    <v-flex  xs5 class="mx-1">
                        <v-text-field box v-model="device.systemName" label="System Name"></v-text-field>
                    </v-flex>
                    <v-flex xs5 class="mx-1">
                        <v-text-field box v-model="device.serialNumber" label="Serial Number"></v-text-field>
                    </v-flex>
                    <v-flex  xs10 class="mx-1">
                        <v-textarea box v-model="device.note" label="Note"></v-textarea>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                  <v-btn @click="editSystemDetails=false, updateDevice()" color="primary" flat>Done</v-btn>

                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="addWarehouseModal" width="500px" persistent>
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Warehouse
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="addWarehouseModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
            <v-layout justify-center wrap>
                <v-flex xs12>
                <v-autocomplete dense  ref="stockWarehouseId" v-on:blur="$refs['stockWarehouseId'].blur()" v-model="device.stockWarehouseId" :items="stockWarehouses" item-text="name" item-value="id"></v-autocomplete>

                </v-flex>
                <v-flex xs12>
                    <v-btn flat color="primary" @click="saveWarehouse()">Save</v-btn>
                </v-flex>

            </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api";
import axios from "axios";
import dateformat from "dateformat";
import TicketSummaryModal from '../components/TicketSummaryModal.vue'
import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea";

const CancelToken = axios.CancelToken;
let source = null
export default {
    components: {
        TicketSummaryModal,
        At,
        AtTa
    },
    data() {
        return {
            addTicketModal: false,
            addWarehouseModal: false,
            allCards: ['u2000ONU', 'u2000OLT'],
            comment: '',
            comments: [],
            commentTab: 0,
            deviceMakeModels: [],
            modelKey: 0,
            deviceMakes: [],
            deviceBridges: [],
            displayCards: [],
            deviceLogHistory: [],
            device: null,
            editSystemDetails: false,
            locationNodes: [],
            locationNetworks: [],
            locations: [],
            loadingLocations: false,
            locationSearch: false,
            editingModel: false,
            loading: false,
            members: [],
            membersEmail: [],
            onuStatus: {
                show: false,
                initiated: false,
                isOnline: false,
                opticRssi: 0,
                rxPower: 0
            },
            oltstatus: {
                show: false,
                initiated: false,
                isOnline: false,
                cpu: 0,
                temperature: 0,
                memory: 0
            },
            serviceAccounts: [],
            stockWarehouses: [],
            tickets: [],
            ticket: {},
            ticketTab: 0,
            statusKey: 0,
            setIntervalId: null,
            rgModeArray: [{
                    id: 1,
                    name: 'Routed'
                },
                {
                    id: 2,
                    name: 'BRouted'
                },
                {
                    id: 3,
                    name: 'rPPPoE'
                },
                {
                    id: 4,
                    name: 'bPPPoE'
                },
                {
                    id: 5,
                    name: 'Bridged'
                },
                {
                    id: 6,
                    name: 'Not Applicable'
                }

            ],
            tpTypeArray: [{
                    id: 1,
                    name: 'Ethernet UNI'
                },
                {
                    id: 2,
                    name: 'VCC Termination Point'
                },
                {
                    id: 3,
                    name: 'Mapper Service Profile'
                },
                {
                    id: 4,
                    name: 'IP Host Config Data'
                },
                {
                    id: 5,
                    name: 'GEM Interworking Termination Point'
                },
                {
                    id: 6,
                    name: 'Multicast GEM Interworking Termination Point'
                },
                {
                    id: 7,
                    name: 'xDSL UNI'
                },
                {
                    id: 8,
                    name: 'VDSL UNI'
                },
                {
                    id: 9,
                    name: 'Ether Flow Termination Point'
                },
                {
                    id: 10,
                    name: 'Physical Path UNI'
                },
                {
                    id: 11,
                    name: 'Physical Path RF Video UNI'
                },
                {
                    id: 12,
                    name: 'Physical Path IPTV UNI'
                },
                {
                    id: 13,
                    name: 'H248 Voice'
                },
                {
                    id: 14,
                    name: 'SIP Voice'
                },
                {
                    id: 15,
                    name: 'SIP PLAR Voice'
                },
                {
                    id: 16,
                    name: 'PWE Termination'
                },
                {
                    id: 17,
                    name: 'Virtual Ethernet'
                },
                {
                    id: 18,
                    name: 'dot11 Termination Point'
                },
                {
                    id: 19,
                    name: 'Fiber LAN Termination Point'
                },
                {
                    id: 20,
                    name: 'TR69 Termination Point'
                },
                {
                    id: 21,
                    name: 'Management Termination Point'
                },
                {
                    id: 22,
                    name: 'MGCP Voice Termination Point'
                }
            ],

        }
    },
    computed: {
        resolvedTickets() {
            let result = this.tickets.filter(x => x.isComplete)
            return result
        },
        pendingTickets() {
            let result = this.tickets.filter(x => !x.isComplete)
            return result
        },
        filteredNetworks() {
            let result = this.locationNetworks
            if (this.device.locationNode) {
                result = result.filter(x => x.locationNodeId == this.device.locationNode.id)
            }
            return result
        },
    },
    async created() {
        source = CancelToken.source();
        this.getDeviceInfo()
        this.getDeviceBridges()
        this.fetchDeviceTickets()
        this.getDeviceMakeModels()
        this.fetchDeviceComments()
        this.fetchServiceAccounts()
        this.fetchDeviceAuditLogs()
            this.fetchLocationNodes()
        this.fetchLocationNetworks()
        this.fetchWarehouses()
    },
    async destroyed() {
        await this.clearIntervalListener(this.setIntervalId);
        source.cancel("Operation canceled by the user.");
    },
    methods: {
        addComment() {
            Api()
                .post("/deviceComments", {
                    deviceId: this.$route.params.deviceId,
                    comment: this.comment
                })
                .then(response => {
                    this.comment = "";
                    response.data.contact = this.$store.state.user;
                    this.comments.unshift(response.data);
                });
        },
        addTicket() {
            this.ticket = {
                currentStatus: 'Pending',
                importance: 'Average',
                dueDate: new Date(),
                deviceId: this.device.id,
                locationId: this.device.locationId,
                location: this.device.location,
                locationNetworkId: this.device.locationNetworkId,
                locationNetwork: this.device.locationNetwork,
                locationNode: this.device.locationNode,
                locationNodeId: this.device.locationNodeId,
                documents: []
            }
            this.addTicketModal = true;

        },
        clearIntervalListener(id) {
            clearInterval(id);
        },
fetchLocationNodes() {
            Api().get('/locationNodes/active').then(res => {
                this.locationNodes = res.data
            })
        },
        fetchLocationNetworks() {
            Api().get('/locationNetworks/basicActive').then(res => {
                this.locationNetworks = res.data
            })
        },
        fetchLocations() {
            if(this.device.locationNetwork){
                this.device.locationNetworkId = this.device.locationNetwork.id
this.loadingLocations = true
            this.locations = []
            Api().get('/locations/active/basic/'+this.device.locationNetworkId).then(res => {
                this.locations = res.data
                this.loadingLocations = false
            })
            }
            
        },
         fetchWarehouses() {
            Api().get('/stockwarehouse').then(res => {
                this.stockWarehouses = res.data
            })
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        formatDateTime(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        async getDeviceMakeModels() {
            await Api()
                .get("/deviceMakeModels")
                .then(response => {
                    this.deviceMakeModels = response.data;
                    this.modelKey++
                });
        },
        fetchDeviceComments() {
            Api()
                .get("/deviceComments/findByDevice/" + this.$route.params.deviceId)
                .then(response => {
                    this.comments = response.data.sort((a, b) => (a.createdAt < b.createdAt) ? 1 : ((b.createdAt < a.createdAt) ? -1 : 0));;
                    //   this.loadingKey += 1
                });
        },
        fetchDeviceTickets() {
            Api()
                .get("/ticket/byDevice/" + this.$route.params.deviceId)
                .then(response => {
                    this.tickets = response.data;
                });
        },
        fetchServiceAccounts() {
            Api()
                .get("/serviceAccounts/active/byDevice/" + this.$route.params.deviceId)
                .then(response => {
                    this.serviceAccounts = response.data;
                });
        },
        fetchDeviceAuditLogs() {
            Api().get('/device/auditlog/' + this.$route.params.deviceId).then(res => {
                this.deviceLogHistory = res.data
            })
        },
        getIcon(val) {
            switch (val) {
                case 'created':
                    return 'add'
                case 'serviceAccount':
                    return 'miscellaneous_services'
                case 'checkedOut':
                    return 'logout'
                case 'checkedIn':
                    return 'login'
                case 'ticket':
                    return 'confirmation_number'
                case 'install':
                    return 'people'
            }
        },
        getOnuStatus(handleId) {
            this.onuStatus.initiated = true
            if (this.onuStatus.complete) {
                this.onuStatus.complete = false
                Api().get('/zhone/onuStatus/' + handleId, {
                        cancelToken: source.token
                    })
                    .then((response, err) => {
                        console.log(err)
                        if (!err) {
                            this.loading = false
                            if (response.data.code == 200) {
                                this.onuStatus = {
                                    show: true,
                                    initiated: true,
                                    isOnline: ((response.data.data.onuStatusWord == '00000000000000000000001') || response.data.data.onuStatusWord == '01000000000000000000001') ? true : false,
                                    opticRssi: parseFloat(response.data.data.opticRssi) / 10,
                                    rxPower: parseFloat(response.data.data.rxPower) / 10,
                                    lastUpdated: new Date(),
                                    complete: true
                                }
                            } else {
                                this.onuStatus = {
                                    show: true,
                                    initiated: true,
                                    isOnline: false,
                                    opticRssi: parseFloat(response.data.data.opticRssi) / 10,
                                    rxPower: parseFloat(response.data.data.rxPower) / 10,
                                    lastUpdated: new Date(),
                                    complete: true
                                }
                            }
                        } else {
                            this.onuStatus = {
                                show: true,
                                initiated: true,
                                isOnline: false,
                            }
                            this.loading = false
                        }

                    })
            }

        },
        async getDeviceInfo() {
            await Api()
                .get("/devices/" + this.$route.params.deviceId)
                .then(async response => {
                    this.device = response.data;
                    this.device.isZhone = this.device.deviceMakeModel.deviceMake.name.toLowerCase() == 'zhone'
                    // if (!this.device.inStock) {
                        this.loading = true
                    // }
                    if (this.device.upstreamDevice) {
                        this.device.upstreamDevice.isZhone = this.device.upstreamDevice.deviceMakeModel.deviceMake.name.toLowerCase() == 'zhone'
                    }
                    if (this.device.isZhone && this.device.deviceMakeModel && this.device.deviceMakeModel.deviceTypeId == 13) {
                        // Zhone OLT/MXK: use deviceInfo (an OLT is not an ONU — onuStatus would 500)
                        this.oltstatus.show = true
                        this.getZhoneOltStatus(this.device.Device_ID || this.device.Handle_ID)
                    } else if (this.device.Handle_ID !== null && this.device.Handle_ID > 0) {

                        // this.getOnuStatus(deviceInfo.Handle_ID);
                        this.onuStatus.complete = true
                        this.onuStatus.show = true
                        this.getOnuStatus(this.device.Handle_ID);
                        this.setIntervalId = setInterval(() => {
                            this.getOnuStatus(this.device.Handle_ID);
                        }, 10000);
                    } else if (this.device.isU2000 && this.device.deviceMakeModel && this.device.deviceMakeModel.deviceTypeId == 1) {
                        this.onuStatus.show = true
                        // this.setIntervalId = setInterval(()=>{
                        this.getU2000OnuStatus(this.device)
                        this.getU2000OnuDetails(this.device)
                        if (this.device.upstreamDevice && this.device.upstreamDevice.isU2000) {
                            this.oltstatus.show = true
                            this.getOltStatus(this.device.upstreamDevice.systemName)
                        }
                        // }, 5000)
                    } else if (this.device.isU2000) {
                        this.oltstatus.show = true
                        this.getOltStatus(this.device.systemName)
                    } else {
                        this.loading = false
                    }
                })
        },
        getU2000OnuStatus(obj) {
            this.onuStatus.initiated = true
            Api().get('/u2000/ontStatus', {
                params: {
                    deviceName: obj.upstreamDevice.systemName,
                    frameId: obj.frame,
                    slotId: obj.slot,
                    portId: obj.port,
                    onuId: obj.ponId
                }
            }).then(res => {
                this.onuStatus.isOnline = res.data.data.RUNSTAT == 'Up' ? true : false
                this.onuStatus.uptime = new Date(res.data.data.LSTUPTIME)
                this.onuStatus.lastDowntime = new Date(res.data.data.LSTDOWNTIME)
                this.onuStatus.lastDownCause = res.data.data.LSTDOWNCAUSE

                this.statusKey++
            })
        },

        getU2000OnuDetails(obj) {
            this.onuStatus.initiated = true
            Api().get('/u2000/ontDDM', {
                params: {
                    deviceName: obj.upstreamDevice.systemName,
                    frameId: obj.frame,
                    slotId: obj.slot,
                    portId: obj.port,
                    onuId: obj.ponId
                }
            }).then(res => {
                this.loading = false
                this.onuStatus.details = res.data.data
                this.statusKey++
            })
        },
        getOltStatus(deviceName) {
            this.oltstatus.initiated = true
            Api().get('/u2000/deviceInfo/' + deviceName).then((response, err) => {
                this.loading = false
                if (err) {
                    this.oltstatus.isOnline = false
                } else {
                    this.oltstatus.isOnline = true
                    this.oltstatus.temperature = response.data.data.TEMPERATURE
                    this.oltstatus.memory = response.data.data.MEM
                    this.oltstatus.cpu = response.data.data.CPU
                    this.oltstatus.name = response.data.data.DEVNAME
                    this.oltstatus.type = response.data.data.DT
                    this.oltstatus.version = response.data.data.DEVER
                    this.oltstatus.ipAddress = response.data.data.DEVIP
                }
            })

        },
        getZhoneOltStatus(deviceId) {
            this.oltstatus.initiated = true
            if (!deviceId) {
                this.oltstatus.isOnline = false
                this.loading = false
                this.statusKey++
                return
            }
            Api().get('/zhone/deviceInfo/' + deviceId).then((response) => {
                this.loading = false
                let body = response.data
                let ok = !!(body && body.code === 200 && body.data && (Array.isArray(body.data) ? body.data.length > 0 : true))
                this.oltstatus.isOnline = ok
                let d = body && body.data ? (Array.isArray(body.data) ? body.data[0] : body.data) : null
                this.oltstatus.name = this.device.systemName
                this.oltstatus.ipAddress = this.device.ipAddress
                if (d && d.Device_Type) this.oltstatus.type = d.Device_Type
                this.statusKey++
            }).catch(() => {
                this.oltstatus.isOnline = false
                this.loading = false
                this.statusKey++
            })
        },
        async getDeviceBridges() {
            await Api()
                .get("/deviceBridge/" + this.$route.params.deviceId)
                .then(response => {
                    this.deviceBridges = response.data;
                    this.loadingKey += 1
                });
        },
        async getAcsProfiles() {
            await Api()
                .get("/deviceBridge/" + this.$route.params.deviceId)
                .then(response => {
                    this.acsProfiles = response.data;
                    this.loadingKey += 1
                });
        },
        routeToTicketSummary(id) {
            this.$router.push({
                path: "/ticketSummary/" + id
            });
        },
        routeToDeviceTable() {
            this.$router.push({
                path: "/devices"
            });
        },
        routeToDeviceSummary(id) {
            this.$router.push({
                path: "/devices/" + id
            });
        },
        routeToServiceAccount(id) {
            this.$router.push({
                path: "/serviceAccounts/" + id
            });
        },
        routeTimeline(item) {
            switch (item.type) {
                case 'serviceAccount':
                    this.routeToServiceAccount(item.id)
                    break
                case 'ticket':
                    this.routeToTicketSummary(item.id)
                    break
            }
        },
        routeToLocation(device) {
            if (device.location) {
                this.$router.push({
                    path: "/locationNetworks/" + device.location.locationNetworkId + "/" + device.locationId
                });
            } else if (device.locationNetwork) {
                this.$router.push({
                    path: "/locationNetworks/" + device.locationNetworkId
                });
            } else if (device.locationNode) {
                this.$router.push({
                    path: "/locationNodes/" + device.locationNodeId
                });
            } else if (device.switchingCentre) {
                this.$router.push({
                    path: "/switchingCentres/" + device.switchingCentreId
                });
            }
        },
        saveWarehouse(){
            if(this.device.stockWarehouseId){
                this.device.inStock = true
                this.device.locationId = null
                this.device.locationNetworkId = null
                this.device.locationNodeId = null
                this.device.switchingCentreId = null
                this.device.stockWarehouse = this.stockWarehouses.find(x=>x.id == this.device.stockWarehouseId)
            }
            this.updateDevice()
        },
        updateDevice() {
            if (this.device.deviceMakeModel) {
                this.device.deviceMakeModelId = this.device.deviceMakeModel.id
            }
            if(this.device.location){
                this.device.locationId = this.device.location.id
            }
            if(this.device.locationNetwork){
                this.device.locationNetworkId = this.device.locationNetwork.id
            }
            if(this.device.locationNode){
                this.device.locationNodeId = this.device.locationNode.id
            }
            Api().put('/devices/' + this.device.id, this.device).then(() => {
                this.editingModel = false
                this.addWarehouseModal=false
            })
        }
    }
}
</script>
